import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import complianceSlice from './slices/complianceSlice';
import dashboardSlice from './slices/dashboardSlice';
import frameworkSlice from './slices/frameworkSlice';
import notificationSlice from './slices/notificationSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    compliance: complianceSlice,
    dashboard: dashboardSlice,
    framework: frameworkSlice,
    notifications: notificationSlice,
  },
  middleware: (getDefault) => getDefault({ serializableCheck: { ignoredActions: ['auth/login/fulfilled'] } }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
